import React from 'react';
import { motion } from 'framer-motion';

interface Category {
  id: string;
  label: string;
}

interface FAQsCategoryTabsProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

const FAQsCategoryTabs: React.FC<FAQsCategoryTabsProps> = ({
  categories,
  activeCategory,
  onCategoryChange,
}) => {
  return (
    <div className="flex flex-wrap justify-center gap-3 mb-12">
      {categories.map((category) => (
        <motion.button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className={`px-6 py-3 rounded-full font-manrope text-lg leading-[28px] transition-all duration-200 ${
            activeCategory === category.id
              ? 'bg-brand-yellow text-[#704b00]'
              : 'bg-transparent text-brand-yellow border border-transparent'
          }`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {category.label}
        </motion.button>
      ))}
    </div>
  );
};

export default FAQsCategoryTabs;
